import styled from 'styled-components'

export const Wrapper = styled.div`
  height: 290px;
  width: 100%;
  display: flex;
  flex-direction: column;
  display: flex;
  padding: 1.1rem 10px;
`

export const Buttons = styled.div`
  margin-top: 25px;
  display: flex;
`

export const CustomLabel = styled.div`
  display: flex;
  align-self: flex-start;
  margin-bottom: 5px;
`

export const LinkContainer = styled.div`
  a {
    display: flex;
    align-items: flex-end;
    color: ${({ theme }) => theme.ds.colors.neutral600};
    font-weight: ${({ theme }) => theme.ds.typography.weight.bold};
    text-decoration: none;
  }
  p {
    display: flex;
    align-items: flex-end;
    font-weight: ${({ theme }) => theme.ds.typography.weight.bold};
    color: ${({ theme }) => theme.ds.colors.neutral600};
  }
  p svg {
    font-size: 20px;
  }
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 15px;
  align-items: center;
  h4 {
    font-size: 1.1rem;
    font-weight: ${({ theme }) => theme.ds.typography.weight.bold};
    color: ${({ theme }) => theme.ds.colors.neutral500};
  }
  svg {
    cursor: pointer;
    fill: ${({ theme }) => theme.ds.colors.neutral900};
  }
`

export const Body = styled.div`
  padding: 0 15px;
  margin: 15px 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-right: auto;
  p {
    font-size: 0.9rem;
    color: ${({ theme }) => theme.ds.colors.neutral600};
    margin-top: 0.5rem;
  }
`

export const line = styled.div`
  margin: 0 auto;
  margin-top: 1rem;
  width: 95%;
  height: 1px;
  background-color: ${({ theme }) => theme.ds.colors.neutral300};
`

export const Form = styled.div`
  width: 95%;
  display: flex;
  margin-top: 1rem;
  margin-left: 15px;
  flex-direction: column;
  display: flex;
`

export const FormButtons = styled.div`
  margin-top: 25px;
  display: flex;
  justify-content: flex-end;

  button {
    width: 25%;
  }
`

export const InvalidedStatus = styled.span`
  font-weight: ${({ theme }) => theme.ds.typography.weight.bold};
  color: ${({ theme }) => theme.ds.colors.danger700};
  font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
`

export const ValidedStatus = styled.span`
  font-weight: ${({ theme }) => theme.ds.typography.weight.bold};
  color: ${({ theme }) => theme.ds.colors.success500};
  font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
`
export const CustomDescription = styled.span`
  font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
`

export const StatusContainer = styled.div`
  margin-top: 8px;
  text-align: left;
`
